<div class="basin-display-flex basin-flex-column basin-height-100">
  <div class="basin-pb-2 basin-width-100">
    Oops! Your session has lapsed because you haven’t been active.
  </div>

  <div class="basin-display-flex basin-justify-content-end basin-width-100">
    <button pButton (click)="refreshPage()" label="OK"></button>
  </div>
</div>